import type { FaireProductEntity } from "../../entity_types/product";

export const p_wvusnmufk4: FaireProductEntity = {
  token: "p_wvusnmufk4",
  type: "product",
  name: "Chill Child: Calm & Sleep Gummy",
  brandToken: "b_gdb388grqx",
  brandName: "SubLuna",
  imageUrl:
    "https://cdn.faire.com/fastly/f3838f66fef2dcb956ba211729f3f0acbc4717864bb5f482dd33823468642c38.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e4f87eb090ddace640fdef11efba21b835014d727ad15aa4c3955445557998eb.png",
    "https://cdn.faire.com/fastly/d6e3baaac5950ceca5dee0eda49755db2435ca368216b883d673327804e95d0a.png",
    "https://cdn.faire.com/fastly/a1f4300bc2682148b3168ff570fa4eacfeca995ea7f799f862deb54d3b58ed72.png",
    "https://cdn.faire.com/fastly/e182b714548d8ee3f4534bcba3017b5ed9df76ad03db17b860d45c150370ed75.png",
    "https://cdn.faire.com/fastly/fdd971c2c9cf0d76283eb61c1177d6a86ef3c90eccdef9a4d9ad636dec9a7006.png",
    "https://cdn.faire.com/fastly/39cce846ba414cd7ce12215f34bfc9690bd5ae355cd59855dcbef31aab3a73df.png",
    "https://cdn.faire.com/fastly/93098be93f42779385528afb938b672be0a4c820f2a9b9f7c3081b94a9f4a74a.png",
    "https://cdn.faire.com/fastly/4be2a81a6996bce4e927d6ba3a6c042ae71dab6c849300d119d78f849114127b.png",
    "https://cdn.faire.com/fastly/fea8a6a36e479b6c21914059bdb06f51b08b7d10a17872d306bae3bfc2fb6d1e.png",
    "https://cdn.faire.com/fastly/390c8834586d70d38709eae3f5957ad8abd30b74a4c4157318694564ebf016d2.png",
  ],
  priceDollars: 21,
  description:
    "Introducing our Ultimate Calming Gummies for Kids – the natural solution for peaceful nights and balanced energy! Our expertly crafted blend of Passionflower, Linden, and Chamomile is combined with the power of Tart Cherry and calming Magnesium and Calcium to harmoniously soothe restless minds, ease growing pains, and support a relaxed, focused state.\n\nPerfect for bedtime, high-energy moments, or times when extra calm is needed, these gummies help settle your child's nervous system quickly and effectively. With a mouthwatering Blueberry Muffin flavor your kids will love, you can feel confident knowing they're enjoying an organic, herbal formula designed to nurture their well-being.\n\nKey Benefits:\n• Instantly soothes anxiety and hyperactivity\n• Promotes restful sleep and muscle relaxation\n• Supports focus, impulse control, and overall calm\n• Made with trusted, organic herbal ingredients\n\nTransform your child's daily routine and make calm moments a natural part of life – try our Ultimate",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:05.441Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
